<svg><use attr.xlink:href="{{this.path()}}"></use></svg>
